<div class="outlet-content">
  <div class="title-1">{{ 'CARTTEXT.address' | translate }}</div>
  <button
    class="supplierAndOutletBtn newOutlet"
    [ngClass]="{ selected: newOutlet.outletId === selectedOutletId }"
    mat-button
    (click)="selectOutlet(newOutlet)"
  >
    <div class="buttonText buttonTextNewOutlet">
      {{ 'new_outlet' | translate }}
    </div>
    <div class="buttonText supplierOutletDeliveryAddress">
      {{ 'add_new_category_for_outlet' | translate }}
    </div>
  </button>
  <ng-container *ngIf="outlets">
    <ng-container *ngFor="let outlet of outlets">
      <button
        class="supplierAndOutletBtn"
        [ngClass]="{ selected: outlet.outletId === selectedOutletId }"
        mat-button
        (click)="selectOutlet(outlet)"
      >
        <div class="buttonText">{{ outlet.outletName }}</div>
        <div class="buttonText supplierOutletDeliveryAddress">
          {{ outlet.address }}
        </div>
      </button>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!outlets">
    <app-loader></app-loader>
  </ng-container>
</div>
<footer
  [ngClass]="{
    'footer-filter-desktop': !mobile,
    'footer-filter d-flex': mobile
  }"
>
  <button
    [ngClass]="{
      'primary-button': !mobile,
      'full-width b2b-button active-button': mobile
    }"
    mat-flat-button
    [disabled]="selectedOutletId === undefined"
    (click)="clickNext()"
  >
    {{ 'go' | translate }}
  </button>
</footer>
